<template>
  <div>
    <div class="bodyBottom d-none d-md-block">
      <div class="bodyBottomHolder">
        <p>
          <span>Order online with confidence using our secure payment system.</span><br />
          <span v-if="localTelNo">Alternatively you can call us on {{ localTelNo }} to place your order.</span>
        </p>
        <ul>
          <li>
            <a href="#">
              <img alt="rbsWorldpay" :src="image_url+'/images/poweredByWorldPay.gif'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="paypal" :src="image_url+'/images/PayPal.gif'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="master-card" :src="image_url+'/images/saterCard.png'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="mastro-card" :src="image_url+'/images/mastroCard.png'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="visa-card" :src="image_url+'/images/visaCard.png'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="amex" :src="image_url+'/images/amex_63x34.png'" />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="bodyBottom d-block d-md-none">
      <div class="bodyBottomHolder">
        <p>
          <span>Order online with confidence using our secure payment system.</span><br />
          <span v-if="localTelNo">Alternatively you can call us on {{ localTelNo }} to place your order.</span>
        </p>
        <ul class>
          <li>
            <a href="#">
              <img alt="rbsWorldpay-mobile" :src="image_url+'/images/l1.jpg'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="master-card-mobile" :src="image_url+'/images/l2.jpg'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="mastro-card-mobile" :src="image_url+'/images/l3.jpg'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="visa-card-mobile" :src="image_url+'/images/l4.jpg'" />
            </a>
          </li>
          <li>
            <a href="#">
              <img alt="jcb-mobile" :src="image_url+'/images/l5.jpg'" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import GenericMixin from "@/assets/mixins/GenericMixin";
export default {
  name: "pageBottom",
  data() {
    return {
      image_url: process.env.VUE_APP_S3_IMAGE_URL
    };
  },
  mixins: [GenericMixin],
};
</script>

<style lang="scss" scoped>
.bodyBottom {
  margin-bottom: 5px;
  margin-top: 15px;
  text-align: center;
  width: 100%;
  border-top: 1px solid #e4e5e4;
  padding-top: 20px;
  padding-bottom: 14px;
  p {
    color: #2f2e2e;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 15px;
  }
  ul {
    width: 100%;
    padding: 0;
    margin: 0;
    li {
      background: transparent none repeat scroll 0 0;
      display: inline-block;
      list-style: outside none none;
      margin: 3px;
      a {
        box-shadow: 2px 2px 7px -1px rgba(0, 0, 0, 0.3);
        display: block;
      }
    }
    li:first-child a {
      box-shadow: none;
    }
  }
}
.d-contact-page,
.training-course,
.elearn,
.orderform,
.course-confirm,
.m-basket-bottom {
  .bodyBottom {
    background-color: white;
    margin-top: -1px;
    margin-bottom: 1px;
    p {
      color: black;
    }
  }
}
.elearn,
.p-bottom,
.course .bodyBottom {
  padding-bottom: 0px;
}
.elearn .bodyBottom {
  padding-bottom: 0px;
}
.p-bottom .bodyBottom {
  padding-bottom: 0px;
}
@media (max-width: 575px) {
  .bodyBottom ul li:first-child a {
    box-shadow: 2px 2px 7px -1px rgba(0, 0, 0, 0.3);
  }
  .bodyBottom {
    margin-bottom: 15px;
    p {
      color: white;
      font-weight: 400;
      font-size: 15px;
    }
    ul {
      li {
        margin: 2px;
        a img {
          width: 60px;
        }
      }
    }
  }
  .p-bottom,
  .course .bodyBottom {
    p {
      color: black !important;
    }
  }
  .d-contact-page,
  .training-course,
  .orderform,
  .course-confirm {
    .bodyBottom {
      background-color: transparent;
      margin-top: 15px;
      margin-bottom: 15px;
      p {
        color: white;
      }
    }
  }
  .m-basket-bottom,
  .forgot-pw {
    .bodyBottom {
      p {
        color: black;
      }
    }
  }
  .delegate .bodyBottom p {
    color: black;
  }
  .elearn .bodyBottom {
    border-top: none;
    padding-bottom: 0px;
  }
  .course .bodyBottom {
    border-top: none;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .p-bottom .bodyBottom {
    margin-bottom: 5px;
    border-top: none;
    margin-top: 0;
  }
}
</style>
